import { apolloClient } from '~/apollo-client';
import { PaymentMethod } from '~/typings/context';
import {
  Flex_FetchExistingPaymentMethodsQuery,
  Flex_FetchExistingPaymentMethodsQueryVariables,
} from '~/typings/graphql';
import { FETCH_EXISTING_PAYMENT_METHODS } from './fetch-existing-payment-method.queries';

export interface FetchExistingPaymentMethodsParams {
  accountId: number;
}

export interface FetchExistingPaymentMethodsResponse {
  existingPaymentMethods: PaymentMethod[];
}

export const fetchExistingPaymentMethods = async (
  params: FetchExistingPaymentMethodsParams,
): Promise<FetchExistingPaymentMethodsResponse> => {
  const { data } = await apolloClient.query<
    Flex_FetchExistingPaymentMethodsQuery,
    Flex_FetchExistingPaymentMethodsQueryVariables
  >({
    query: FETCH_EXISTING_PAYMENT_METHODS,
    variables: { accountId: params.accountId },
  });

  return { existingPaymentMethods: data.account.paymentMethods };
};
